import config from "../../config/config.json";
import { fileHeaders, headers } from "../../APIHelpers/Headers";
import axios from "axios";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../APIHelpers/Responses";

export const s3FileManagerServices = {
  //Folder
  getS3Folders,
  createS3Folder,
  moveS3Folder,
  copyS3Folder,
  updateS3Folder,
  duplicateS3Folder,
  deleteS3FolderFile,
  softDeleteS3Folder,

  //File
  uploadFilesToS3,
  moveS3File,
  createS3ZipController,
  extractS3ZipController,
  uploadMultipleLocalS3Folder
};

// Upload MultiFile
async function uploadFilesToS3(formData) {
  const response = await axios.post(
      `${config.API_URL_USER_ONBOARDING}uploadFilesToS3`,
      formData,
      {
        headers: fileHeaders,
      }
    );
    const data = response?.data;
    handleResponse(data);
    return data;
}

async function uploadMultipleLocalS3Folder(formData) {
  const response = await axios.post(
    `${config.API_URL_USER_ONBOARDING}uploadMultipleLocalS3Folder`,
    formData,
    {
      headers: fileHeaders,
    }
  );
  const data = response?.data;
  handleResponse(data);
  return data;
};

async function moveS3File(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}moveS3File`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function createS3ZipController(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}createS3ZipController`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function extractS3ZipController(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}extractS3ZipController`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function getS3Folders(type, searchData, path, dataType) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getS3Folders/${type}?search=${searchData || ""}&path=${path || ""}&dataType=${dataType || ""}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function createS3Folder(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}createS3Folder`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function softDeleteS3Folder(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteS3Folder`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function moveS3Folder(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}moveS3Folder`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function copyS3Folder(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}copyS3Folder`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function updateS3Folder(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateS3Folder`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function duplicateS3Folder(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}duplicateS3Folder`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function deleteS3FolderFile(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteS3FolderFile`,
    headersWithAuth("DELETE", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}